// form rekam medis
import Informasi from "../../assets/images/rekamedis/info.svg";
import Rekamedis from "../../assets/images/rekamedis/rekamedis.svg";
import Keluhan from "../../assets/images/rekamedis/keluhan.svg";
import Diagnosa from "../../assets/images/rekamedis/diagnosa.svg";
import Tindakan from "../../assets/images/rekamedis/tindakan.svg";

// health emojis
import Sehat from "../../assets/images/rekamedis/sehat.svg";
import Pusing from "../../assets/images/rekamedis/pusing.svg";
import Demam from "../../assets/images/rekamedis/demam.svg";
import Mual from "../../assets/images/rekamedis/mual.svg";
import Sakit from "../../assets/images/rekamedis/sakit.svg";

const createIcon =
  (
    src: string,
    alt: string
  ): React.FC<React.ImgHTMLAttributes<HTMLImageElement>> =>
  (props) =>
    <img src={src} alt={alt} loading="lazy" {...props} />;

// form rekam medis
export const InformasiIcon = createIcon(Informasi, "Informasi");
export const RekamedisIcon = createIcon(Rekamedis, "Rekamedis");
export const KeluhanIcon = createIcon(Keluhan, "Keluhan");
export const DiagnosaIcon = createIcon(Diagnosa, "Diagnosa");
export const TindakanIcon = createIcon(Tindakan, "Tindakan");

// health emojis
export const SehatIcon = createIcon(Sehat, "Sehat");
export const PusingIcon = createIcon(Pusing, "Pusing");
export const DemamIcon = createIcon(Demam, "Demam");
export const MualIcon = createIcon(Mual, "Mual");
export const SakitIcon = createIcon(Sakit, "Sakit");
